import {
  CREATE_ARTICLE_TYPES_SUCCESS,
  CREATE_ARTICLE_TYPES_FAIL,
  RETRIEVE_ARTICLE_TYPES_SUCCESS,
  RETRIEVE_ARTICLE_TYPES_FAIL,
  UPDATE_ARTICLE_TYPES_SUCCESS,
  UPDATE_ARTICLE_TYPES_FAIL,
  DELETE_ARTICLE_TYPES_SUCCESS,
  DELETE_ARTICLE_TYPES_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_ARTICLE_TYPES_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_ARTICLE_TYPES_SUCCESS:
      return payload;

    case RETRIEVE_ARTICLE_TYPES_FAIL:
      return [...datas];

    case UPDATE_ARTICLE_TYPES_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_ARTICLE_TYPES_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
